import { render, staticRenderFns } from "./GChatAttachmentFile.vue?vue&type=template&id=c7ee4aee&scoped=true&"
import script from "./GChatAttachmentFile.vue?vue&type=script&lang=ts&"
export * from "./GChatAttachmentFile.vue?vue&type=script&lang=ts&"
import style0 from "./GChatAttachmentFile.vue?vue&type=style&index=0&id=c7ee4aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ee4aee",
  null
  
)

export default component.exports